module.exports = __webpack_public_path__ + "img/banner2.54419a90.png";